import { render, staticRenderFns } from "./oridinaryAnalysis.vue?vue&type=template&id=16c2b04d"
import script from "./oridinaryAnalysis.vue?vue&type=script&lang=js"
export * from "./oridinaryAnalysis.vue?vue&type=script&lang=js"
import style0 from "./oridinaryAnalysis.vue?vue&type=style&index=0&id=16c2b04d&prod&lang=css"
import style1 from "./oridinaryAnalysis.vue?vue&type=style&index=1&id=16c2b04d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports